export default "__VITE_ASSET__DBag3Uj6__"